<template>
  <div>
    <vue-good-table
      v-if="users"
      style="width: 100%"
      :columns="tableColumns"
      styleClass="vgt-table"
      :rows="users"
      @on-row-click="({row}) => click(row)"
    >
      <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field == 'account'">
          <router-link
            @click.native.stop
            v-if="props.row.account"
            :to="{ name: 'accounts.view', params: { accountId: props.row.account.id } }"
            class="btn btn-link justify-content-start p-0 text-left"
          >
            {{ props.row.account.name }}
          </router-link>
          <span v-else>
            &mdash;
          </span>
        </span>
        <span v-else-if="props.column.field == 'lastSeen'">
          <span
            v-if="props.row.last_seen_at"
            v-date="{ date: props.row.last_seen_at, timeAgo: true }"
          />
          <span v-else>
            Never
          </span>
        </span>
        <span v-else-if="props.column.field == 'gdpr'">
          <icon
            v-if="props.row.is_gdpr_compliant"
            class="positive"
            icon="tick"
          />
          <icon
            v-else
            class="negative"
            icon="cross-badge"
          />

        </span>
        <span v-else-if="props.column.field == 'menu'">
          <dropdown
            v-if="$login.can('users.update') || $login.can('users.ghost-in') || $login.can('users.admin-ghost-in')"
            trigger="click"
            alignment="right"
            @click.native.stop
            class="no-chev"
          >
            <button
              slot="trigger"
              class="btn-link btn"
              style="background: transparent;"
            >
              <icon icon="more-vertical" />
            </button>
            <dropdown-option
              v-if="$login.can('users.update')"
              class="page-header-dropdown-option"
              @click.native="sendForgotTo(props.row)"
            >
              <icon icon="password" /> Send forgot password
            </dropdown-option>

            <dropdown-option
              v-if="$login.can('users.update') && !props.row.agreed_to_terms_of_use_at && false"
              class="page-header-dropdown-option"
              @click.native="sendWelcomeTo(props.row)"
            >
              <icon icon="welcome" /> Send Welcome email
            </dropdown-option>

            <dropdown-option
              v-if="props.row && $login.can('users.update') && !props.row.activatedAt"
              class="page-header-dropdown-option"
              @click.native="sendInviteTo(props.row)"
            >
              <icon icon="delivered" /> Invite to Insights {{ props.row.is_pro ? 'Pro' : 'Starter' }}
            </dropdown-option>

            <dropdown-option
              v-if="$login.can('users.update') && !props.row.is_gdpr_compliant && false"
              class="page-header-dropdown-option"
              @click.native="sendGdprTo(props.row)"
            >
              <icon icon="delivered" /> Send GDPR email
            </dropdown-option>

            <dropdown-option
              v-if="$login.can('users.ghost-in')"
              class="page-header-dropdown-option"
              @click.native="ghost(props.row)"
            >
              <icon icon="ghost" /> Ghost in
            </dropdown-option>
            <dropdown-option
              v-if="$login.can('users.admin-ghost-in')"
              class="page-header-dropdown-option"
              @click.native="ghost(props.row, true)"
            >
              <icon icon="ghost" /> Admin Ghost in
            </dropdown-option>

            <slot
              name="options"
              :user="props.row"
            />
          </dropdown>

        </span>
        <span v-else>
          {{props.formattedRow[props.column.field]}}
        </span>
      </template>
    </vue-good-table>
    <confirm
      v-if="sendWelcomeToUser"
      modal="confirm-send-welcome"
      @confirmed="() => sendWelcome(sendWelcomeToUser)"
    >
      Are you sure you want to send a welcome email to {{ sendWelcomeToUser.name }}?
    </confirm>
    <confirm
      v-if="sendGdprToUser"
      modal="confirm-send-gdpr"
      @confirmed="() => sendGdpr(sendGdprToUser)"
    >
      Are you sure you want to send a GDPR email to {{ sendGdprToUser.name }}?
    </confirm>

    <confirm
      v-if="sendForgotUser"
      modal="confirm-send-forgot"
      @confirmed="sendForgot"
    >
      Are you sure you want to send a forgot password email to {{ sendForgotUser.name }}?
    </confirm>

    <confirm
      v-if="sendInviteToUser"
      modal="confirm-send-invite"
      @confirmed="sendInvite"
    >
      Are you sure you want to send an invite to {{ sendInviteToUser.name }}?
    </confirm>
  </div>
</template>

<script>
import {VueGoodTable} from 'vue-good-table'
import mixin from './Mixin'
import Date from '@/directives/date'
import Confirm from '@/components/Confirm'
import Dropdown from '@/components/Dropdown/Dropdown'
import DropdownOption from '@/components/Dropdown/DropdownOption'

export default {
  mixins: [mixin],

  components: {
    VueGoodTable,
    Confirm,
    Dropdown,
    DropdownOption,
  },

  directives: {
    Date,
  },

  props: {
    users: {
      required: true,
      type: Array,
    },
  },

  data() {
    return {
      tableColumns: [
        {
          label: 'Name',
          field: 'name',
        },
        ...(this.$login.can('users.update') ? [{label: 'Email', field: 'email'}] : []),
        {
          label: 'Account',
          field: 'account',
        },
        {
          label: 'Last Seen At',
          field: 'lastSeen',
        },
        {
          label: 'GDPR Compliant',
          field: 'gdpr',
        },
        {
          label: '',
          field: 'menu',
        },
      ]
    }
  },

  methods: {
    click (row) {
      this.$router.push({
        name: 'users.view',
        params: {
          userId: row.id,
        },
      })
    },
  },
}
</script>
